// /**
//  * Heuristic Store Module
//  * @module Heuristic
//  */

export default {
    state: {
        heuristicStructure: [],
    },
}